import { render, staticRenderFns } from "./RolesCrudPage.vue?vue&type=template&id=8f61d40e"
import script from "./RolesCrudPage.vue?vue&type=script&lang=js"
export * from "./RolesCrudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports